const Popup = (function () {

    const $ = require('jquery');
    const self = {};

    self.$popupLink = $('[data-popup="video"]');

    self.init = function () {

        if (self.$popupLink.length > 0) {

            require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

            $('[data-popup="video"]').magnificPopup({
                disableOn: 600,
                type: 'iframe'
            });

        }

    };

    return self;

}());

module.exports = Popup;
